module.exports = __webpack_public_path__ + "static/plan-action-in-action-8903d80b3b861307b823b7273866325b.svg";